var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreOptions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99922 5.40078C8.00511 5.40078 7.19922 4.59489 7.19922 3.60078C7.19922 2.60667 8.00511 1.80078 8.99922 1.80078C9.99333 1.80078 10.7992 2.60667 10.7992 3.60078C10.7992 4.59489 9.99333 5.40078 8.99922 5.40078Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99922 10.8008C8.00511 10.8008 7.19922 9.99489 7.19922 9.00078C7.19922 8.00667 8.00511 7.20078 8.99922 7.20078C9.99333 7.20078 10.7992 8.00667 10.7992 9.00078C10.7992 9.99489 9.99333 10.8008 8.99922 10.8008Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99922 16.2008C8.00511 16.2008 7.19922 15.3949 7.19922 14.4008C7.19922 13.4067 8.00511 12.6008 8.99922 12.6008C9.99333 12.6008 10.7992 13.4067 10.7992 14.4008C10.7992 15.3949 9.99333 16.2008 8.99922 16.2008Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/more-options.94df236542deeab87817835a7e7000e3.svg";
export { ForwardRef as ReactComponent };